/**
 * History Tab Component
 *
 * Displays state transition history for offerings.
 * Shows lifecycle events (activate, expire) with full audit trail.
 *
 * Uses MetadataTable for automatic:
 * - Data fetching from /state-history/search
 * - Pagination, sorting, filtering
 * - Presets, search, advanced filters
 * - Column customization
 *
 * Note: baseFilters and emptyMessage now come from backend metadata
 * (statetransitionhistory.yaml _meta.base_filters and _meta.display.empty_message)
 */

import { MetadataTable } from '@/components/MetadataTable'

export function HistoryTab() {
  return (
    <MetadataTable
      endpoint="/state-history"
    />
  )
}
